export function userLoggedIn(login){
    return login && login.userLoggedIn;
}

export function admin(login){
    return login.roles.includes("ROLE_ADMIN");
}